import React, { useState } from 'react';
import { Form, Field } from 'react-final-form';
import { connect } from 'react-redux';
import styles from './Step2_UserDetails.module.scss';
import formatString from 'format-string-by-pattern';
import PropTypes from 'prop-types';

import { Button } from 'components';
import FormAddressAutoCompleteField from 'components/FormAddressAutoCompleteField/FormAddressAutoCompleteField';
import FormInputField from 'components/FormInputField/FormInputField';
import ProgressBar from 'components/ProgressBar/ProgressBar';
import AdditionalLocationsFieldGroup from 'containers/LocationFieldGroup/AdditionalLocationsFieldGroup/AdditionalLocationsFieldGroup';
import ReferralCodeGenerator from 'containers/ReferralCodeGenerator/ReferralCodeGenerator';
import { DEFAULT_PHONE_FIELD_MASK } from 'coupon-common';
import { actions as referralCodesActions } from 'coupon-common/src/modules/referralCodes';
import { actions as signupActions } from 'coupon-common/src/modules/signup';
import {   composeSyncValidators,
  required,
  validPhone, dispatchAsAsync
} from 'coupon-common/src/utils';


const Step2_UserDetails = ({
  initialValues,
  onBack,
  onNext,
  currentStep,
  totalSteps,
  dispatch,
  code,
  setSignUpFlowActive,
  onSkip,
}) => {
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const phoneFieldMask = formatString(DEFAULT_PHONE_FIELD_MASK);

  const validate = v => {
    const e = {};

    if (!v.contact_name) e.contact_name = 'Contact name is required';
    if (!v.email) e.email = 'Email is required';
    if (!v.password)
      e.password = !v.password
        ? 'Password is required'
        : v.password.length < 8
        ? 'Min 8 characters'
        : undefined;
    if (!v.confirmPassword) e.confirmPassword = 'Confirm password';
    else if (v.password !== v.confirmPassword)
      e.confirmPassword = 'Passwords do not match';
    if (!v.name) e.name = 'Business name required';
    if (!v.street) e.street = 'Address required';
    if (!v.city) e.city = 'City required';
    if (v.is_service_area_business) {
      const cities = Array.isArray(v.additional_cities)
        ? v.additional_cities
        : [];
      if (cities.length === 0) {
        e.additional_cities = 'Please select at least one city.';
      }
    }
    // if (v.is_service_area_business && !v.additionalProvinces) {
    //   e.additionalProvinces = 'Please select a province.';
    // }

    return e;
  };

  // const onSubmit = async (values) => {
  //   setLoading(true);
  //   setErrorMessage(''); // Clear previous error

  //   try {
  //     setSignUpFlowActive(true);

  //     const payload = values;
  //     if (!code) {
  //       dispatch(referralCodesActions.generateCode());
  //       // dispatch(referralCodesActions.openCodeGenerator());
  //       // setLoading(false);
  //       // return;
  //     }

  //     const submitErrors = await dispatchAsAsync(signupActions.signUp(payload), dispatch);

  //     if (submitErrors) {
  //       setErrorMessage(submitErrors.message || 'Something went wrong. Please try again.');
  //     } else {
  //       dispatch(referralCodesActions.resetCodeGenerator());
  //       onNext(values);
  //     }
  //   } catch (err) {
  //     console.error('Error submitting Step2:', err);
  //     setErrorMessage('Something went wrong. Please try again.');
  //   } finally {
  //     setLoading(false);
  //   }
  //   // onNext(values);
  // };
  const onSubmit = async values => {
    setLoading(true);
    setErrorMessage('');

    try {
      setSignUpFlowActive(true);

      // Generate code if it doesn't exist
      let referral_code = code;
      if (!code) {
        // Dispatch action and wait for the generated code
        referral_code = await dispatchAsAsync(
          referralCodesActions.generateCode(),
          dispatch,
        );
      }

      // Include the referral code in payload
      const payload = {
        ...values,
        referral_code: referral_code,
        additional_cities: values.is_service_area_business
          ? Array.isArray(values.additional_cities)
            ? values.additional_cities.map(c => c.id)
            : []
          : [],
      };

      // const payload = {
      //   ...values,
      //   referral_code: referral_code,
      // };


      const submitErrors = await dispatchAsAsync(
        signupActions.signUp(payload),
        dispatch,
      );

      if (submitErrors) {
        setErrorMessage(
          submitErrors.message || 'Something went wrong. Please try again.',
        );
      } else {
        dispatch(referralCodesActions.resetCodeGenerator());
        onNext(values);
      }
    } catch (err) {
      console.error('Error submitting Step2:', err);
      setErrorMessage('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.formContainer}>
      <ProgressBar
        currentStep={currentStep}
        totalSteps={totalSteps}
        label="Account Information"
      />
      <Form
        onSubmit={onSubmit}
        initialValues={initialValues}
        validate={validate}
        render={({ handleSubmit, form, submitting, pristine }) => (
          <form onSubmit={handleSubmit}>
            <FormInputField
              name="contact_name"
              label="First Name"
              placeholder="John"
            />
            <FormInputField
              name="lastName"
              label="Last Name"
              placeholder="Doe"
            />
            <FormInputField name="email" label="Email" type="email" disabled />
            <FormInputField
              name="password"
              label="Password"
              type="password"
              placeholder="********"
            />
            <FormInputField
              name="confirmPassword"
              label="Confirm Password"
              type="password"
              placeholder="********"
            />
            <FormInputField
              name="name"
              label="Business Name"
              placeholder="My Business"
            />

            <FormAddressAutoCompleteField form={form} />

            <div className={styles.serviceToggleRow}>
              <Field
                name="is_service_area_business"
                type="checkbox"
                // initialValue={false}
                initialValues={{
                  ...initialValues,
                  is_service_area_business:
                    initialValues?.is_service_area_business ?? false,
                }}
              >
                {({ input }) => (
                  <label className={styles.serviceToggle}>
                    <input
                      {...input}
                      onChange={e => {
                        const checked = e.target.checked;
                        input.onChange(checked);

                        if (!checked) {
                          form.change('additionalProvinces', undefined);
                          form.change('searchCities', '');
                          form.change('additional_cities', []);
                        }
                      }}
                    />
                    <span>
                      I deliver goods or provide services to customers at their
                      location.
                    </span>
                  </label>
                )}
              </Field>
            </div>

            <Field
              name="is_service_area_business"
              subscription={{ value: true }}
            >
              {({ input: { value: enabled } }) => (
                <div
                  className={`${styles.serviceAreaWrap} ${
                    enabled ? styles.open : styles.closed
                  }`}
                  aria-hidden={!enabled}
                >
                  <div className={styles.serviceAreaInner}>
                    <div className={styles.serviceAreaTitle}>
                      Select the cities you provide your goods/services
                    </div>

                    {/* Reuse existing additional cities UI */}
                    <AdditionalLocationsFieldGroup />

                    {/* Optional: show helper validation text if your group writes error to a known key */}
                  </div>
                </div>
              )}
            </Field>

            <FormInputField
              name="phone"
              label="Business Phone"
              type="tel"
              placeholder="(123) 456-7890"
              validate={composeSyncValidators(required, validPhone())}
              parse={phoneFieldMask}
              maxLength={14}
            />

            <ReferralCodeGenerator onConfirm={() => form.submit()} />

            {/* Display centralized error message */}
            {errorMessage && (
              <div style={{ color: 'red', margin: '5px', fontSize: '11px' }}>
                {errorMessage}
              </div>
            )}

            <div className={styles.buttonWrapper}>
              <Button outline type="button" onClick={onBack} disabled={loading}>
                Back
              </Button>
              <Button
                type="submit"
                fetching={loading}
                disabled={loading || submitting}
              >
                Create Account
              </Button>
              {/* <Button onClick={onSkip}>
                skip
              </Button> */}
            </div>
          </form>
        )}
      />
    </div>
  );
};

Step2_UserDetails.propTypes = {
  initialValues: PropTypes.object,
  onBack: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
  currentStep: PropTypes.number,
  totalSteps: PropTypes.number,
  locations: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
};

export default connect()(Step2_UserDetails);
